import './tweenmax.js';

const SLOT_COUNT = 9; // số ô trên mỗi vòng quay

// DEBUG: ép quà trúng theo mã "A".."R" (khớp prodTemplate.items).
// Để "" (rỗng) hoặc null để dùng kết quả thật trả về từ server.
const DEBUG_PRIZE = "";

// Xoay 1 đĩa (wheel) bằng GSAP TweenMax (cơ chế từ naraka)
class DnDRotate {
    constructor(wheel) {
        this.wheel = wheel; // jQuery element của đĩa đang quay
        this.temp = -1;
        this.angleObj = { angle: 0 };
        // Giữ 1 tham chiếu bind cố định để add/remove ticker khớp nhau
        this._loop = this.loop.bind(this);
    }

    loop() {
        this.drawRotated(this.angleObj.angle);
        if (this.angleObj.angle === this.temp) {
            TweenLite.ticker.removeEventListener("tick", this._loop);
        }
        this.temp = this.angleObj.angle;
    }

    drawRotated(degrees) {
        this.wheel.css("transform", `rotate(${degrees}deg)`);
        // Giữ ảnh quà luôn thẳng đứng trong khi đĩa xoay (xoay ngược lại)
        this.wheel.find(".reward").css("transform", `rotate(${-degrees}deg)`);
    }

    animateRotate(targetAngle, onDone) {
        TweenMax.to(this.angleObj, 5, {
            angle: targetAngle,
            delay: 0,
            repeat: 0,
            onComplete: onDone
        });

        setTimeout(() => {
            TweenLite.ticker.addEventListener("tick", this._loop);
        }, 0);
    }
}

// Trả đĩa về vị trí ban đầu — không transition để không thấy quay ngược
const resetWheel = (wheel) => {
    wheel.css("transform", "rotate(0deg)");
    wheel.find(".reward").css("transform", "rotate(0deg)");
};

// Quay 4 vòng rồi dừng sao cho ô trúng (slot 0..8) lên TRÊN CÙNG (12 giờ)
const AnimationLucky = (wheel, slot) => {
    const rotateModule = new DnDRotate(wheel);
    const ketQua = 360 * 4 - slot * (360 / SLOT_COUNT);
    rotateModule.animateRotate(ketQua, () => {
        // Quay xong -> popup trúng thưởng hiện ra -> trả đĩa về cũ (ẩn sau popup)
        setTimeout(() => resetWheel(wheel), 600);
    });
};

// Đổi tab: kích hoạt nút tab + đĩa quay + ảnh preview tương ứng
const activateTab = (name) => {
    $(".tab-btn").removeClass("active");
    $(".tab-" + name).addClass("active");
    $(".circle .wheel").removeClass("active");
    $(".wheel-" + name).addClass("active");
    $(".preview-img").removeClass("active");
    $(".preview-" + name).addClass("active");
};

window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;

    // Tab Ngoại Trang / Thú Cưỡi -> đổi đĩa quay + preview
    $(".tab-btn").on("click", function (e) {
        e.preventDefault();
        activateTab($(this).data("preview"));
    });

    // timeWait khớp thời lượng xoay (TweenMax 5s)
    const promotionConfig = {
        timeWait: 5000,
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items, // quà chung A..R (1..18)
        names: prodTemplate.names,
        config: promotionConfig,
        animResult: function (listPrize) {
            // DEBUG_PRIZE ("A".."R") ép quà trúng; rỗng -> dùng kết quả server
            const prizeIndex = DEBUG_PRIZE
                ? Number(prodTemplate.items[DEBUG_PRIZE])
                : Number(listPrize[0].indexImg); // 1..18
            // Quay ĐÚNG đĩa của tab đang chọn (không nhảy tab).
            // slot 0..8 theo dải: 1-9 -> 0-8, 10-18 -> 0-8
            const slot = (((prizeIndex - 1) % SLOT_COUNT) + SLOT_COUNT) % SLOT_COUNT;
            const activeWheel = $(".circle .wheel.active");
            AnimationLucky(activeWheel, slot);

            // DEBUG: ép nội dung popup khớp DEBUG_PRIZE (lib debug luôn trả 1 quà cố định)
            if (DEBUG_PRIZE) {
                const names = (prodTemplate.names && prodTemplate.names[prodTemplate.locate || "vn"]) || {};
                const name = names[DEBUG_PRIZE] || DEBUG_PRIZE;
                const src = prodTemplate.directory + "/" + prizeIndex + "." + prodTemplate.items.type;
                const html = '<div class="item"><img src="' + src + '" alt=""><div class="item-name">' + name + '</div></div>';
                // ghi đè ngay + ghi lại sau khi lib mở popup (đảm bảo là bản cuối)
                $("#rewardContainer").html(html);
                setTimeout(function () {
                    $("#rewardContainer").html(html);
                    $("#popup_reward").removeClass("gift-5 gift-10").addClass("gift-1");
                }, promotionConfig.timeWait + 250);
            }
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") {
                prodTemplate.fnPromotion();
            }
        },
    });
});
